import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { SharedModule } from 'app/shared/shared.module';

import { ChatListComponent } from './chat-list.component';
import { NewChatComponent } from './new-chat/new-chat.component';
import { ChatMessageComponent } from './chat-message/chat-message.component';
// import { MessageNormalViewComponent } from './chat-message/msg-normal-view/msg-normal-view.component';

//import { AudioCallViewComponent } from './chat-message/audio-call-view/audio-call-view.component';
import { MessagListViewComponent } from './chat-message/msg-list-view/msg-list-view.component';
import { GroupUserlistComponent } from './group-userlist/group-userlist.component';
import { ChatListRoutingModule } from './chat-list-routing.module';
import { ChatService } from './chat.service';
import { AudioCallViewComponent } from "./chat-message/audio-call-view/audio-call-view.component";
import { DataSharingService } from 'app/shared/data-sharing.service';
import { SocketService } from 'app/socket/socket.service';
import { ConfirmationDialogService } from 'app/confirmation-dialog/confirmation-dialog.service';
import { MomentModule } from 'ngx-moment';





@NgModule({ declarations: [
        ChatListComponent,
        NewChatComponent,
        ChatMessageComponent,
        // MessageNormalViewComponent,
        AudioCallViewComponent,
        MessagListViewComponent,
        GroupUserlistComponent
    ], imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        ChatListRoutingModule,
        SharedModule,
        MomentModule], providers: [ChatService, ConfirmationDialogService, provideHttpClient(withInterceptorsFromDi()),] })
export class ChatListModule { }
